$(window).scroll(function() {
    if($(window).scrollTop() === $(document).height() - $(window).height()) {
        // Make sure ajaxData is defined and not null
        if (typeof ajaxData !== 'undefined' && ajaxData !== null) {
            $("#loadonscroll").html(ajaxData);
        }
    }
});
var slideIndex = 1;
var count = $("div.container-gallery-images").length;
add_attr(count);
showSlides(slideIndex);
function plusSlides(n) {
    showSlides(slideIndex += n);
}
function currentSlide(n) {
    showSlides(slideIndex = n);
}
function showSlides(n, CurrentSlide) {
    var i;
    
    // Check if CurrentSlide is provided
    if (!CurrentSlide) {
        console.warn("CurrentSlide is undefined.");
        return;
    }
    
    var slides = document.getElementsByClassName(CurrentSlide);
    var dots = document.getElementsByClassName("demo");
    var captionText = document.getElementById("caption");
    if (slides.length === 0) {
        console.warn(`No slides found with class ${CurrentSlide}`);
        return;
    }
    if (n > slides.length) { slideIndex = 1; }
    if (n < 1) { slideIndex = slides.length; }
    for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
    }
    
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
    }
    
    if (slides[slideIndex - 1]) {
        slides[slideIndex - 1].style.display = "flex";
    }
    if (dots[slideIndex - 1]) {
        dots[slideIndex - 1].className += " active";
    }
    if (captionText && dots[slideIndex - 1]) {
        captionText.innerHTML = dots[slideIndex - 1].alt;
    }
}
// Add IDs to parents
function add_attr(NumGallery) {
    for (let i = 0; i < NumGallery; i++) {
        var sections = $("section.images");
        
        // Check if section exists at index i
        if (!sections[i]) {
            console.warn(`No section found at index ${i}`);
            continue;
        }
        
        var NumImages = sections[i].children.length;
        
        for (let j = 0; j < NumImages; j++) {
            var slideClass = `mySlides mySlides-${i}-${j} mySlides-${i}`;
            sections[i].children[j].setAttribute("class", slideClass);
            
            // Only set up the first slide in each gallery
            if (j === 0) {
                var CurrentSlide = `mySlides-${i}`;
                showSlides(1, CurrentSlide);
            }
        }
        var containerGallery = document.getElementsByClassName("container-gallery-images")[i];
        if (containerGallery) {
            containerGallery.setAttribute("id", `input_${i}`);
        }
    }
}
// Helper functions with undefined checks
function item(list, object) {
    return Array.isArray(list) ? list.indexOf(object) : -1;
}
function counter(list, object) {
    return Array.isArray(list) ? list.indexOf(object) + 1 : 0;
}
function listitem(list, object) {
    if (!Array.isArray(list)) return -1;
    return list.findIndex(function(item) {
        return item.imagequote === object;
    });
}
function listbrands(list, object) {
    if (!Array.isArray(list)) return -1;
    return list.findIndex(function(item) {
        return item.imgbrand1 === object;
    });
}